module.exports = __webpack_public_path__ + "img/wine-body_grey.7ccf620a.svg";